// Inline SVG icons only (Lucide, ISC, plus a few drawn on the same 24 px grid). Never Unicode
// glyphs or emoji for UI symbols: iOS renders those as emoji. Every icon in the product goes
// through this file.
import type { LucideIcon } from 'lucide-react';

export function Icon({ icon: Glyph, size = '1.25em', label }: { icon: LucideIcon; size?: string | number; label?: string }) {
  if (label) {
    return <Glyph width={size} height={size} strokeWidth={1.75} role="img" aria-label={label} focusable="false" />;
  }
  return <Glyph width={size} height={size} strokeWidth={1.75} aria-hidden="true" focusable="false" />;
}

/**
 * An icon drawn from stroke paths on the 24 px grid, for symbols Lucide doesn't carry. Decorative,
 * sized by font-size and coloured by currentColor, exactly as the owner's rule writes it.
 */
export function PathIcon({ paths, className }: { paths: readonly string[]; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      {paths.map(d => <path key={d} d={d} />)}
    </svg>
  );
}
